import * as yup from "yup";

export const domainSchema = yup
  .string()
  .matches(/^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/, "Invalid domain format.")
  .required("Domain is required");
